import endpoints from '../endpoints/moderation';

function twoWayVerification(spotId, status) {
  return endpoints.twoWayVerification.execute({ status }, { spotId });
}

function verifyCode(spotId, code) {
  return endpoints.verifyCode.execute({ code }, { spotId });
}

function setSuperOwner(spotId, token) {
  var payload = {
    spot_id: spotId,
    token: token
  };

  return endpoints.setSuperOwner.execute(payload);
}

export default {
  twoWayVerification,
  verifyCode,
  setSuperOwner
};
